import React from 'react'
// import avatar from '../../../assets/images/avatar.png'
import avatar from '../../../assets/images/avatar.png'
import { HexagonIcon } from '../../../SvgIconsData'


const ChampCard = () => {
    return (
        <>
            <div className="championsnaem position-relative z-1">
                <h1 className='text-center headinfgfg'>Champions</h1>
                <div className="row">
                    <div className="col-md-4">
                        <div className="championcard gold text-center">
                            <h1 className='text-end'>1<sup>st</sup></h1>
                            <div className="champimg">
                                <img src="https://lh3.googleusercontent.com/a/ACg8ocKCZ_CRMjOfGjfgeotB758g31CvxfeX9P8PD1RXy7IiNw=s288-c-no" alt="" />
                            </div>
                            <p className='font-xs mb-0 mt-1'><strong>Sunil Kumar</strong></p>
                            <p className='font-xss mb-0'>sunilyadav@simulanis.com</p>
                            <div className='score'>
                                <h6 className='mb-0'>Score</h6>
                                <h2>21354</h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="championcard silver text-center">
                            <h1 className='text-end'>2<sup>nd</sup></h1>
                            <div className="champimg">
                                <img src="https://lh3.googleusercontent.com/a/ACg8ocKCZ_CRMjOfGjfgeotB758g31CvxfeX9P8PD1RXy7IiNw=s288-c-no" alt="" />
                            </div>
                            <p className='font-xs mb-0 mt-1'><strong>Sunil Kumar</strong></p>
                            <p className='font-xss mb-0'>sunilyadav@simulanis.com</p>
                            <div className='score'>
                                <h6 className='mb-0'>Score</h6>
                                <h2>21354</h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="championcard bronze text-center">
                            <h1 className='text-end'>3<sup>rd</sup></h1>
                            <div className="champimg">
                                <img src="https://lh3.googleusercontent.com/a/ACg8ocKCZ_CRMjOfGjfgeotB758g31CvxfeX9P8PD1RXy7IiNw=s288-c-no" alt="" />
                            </div>
                            <p className='font-xs mb-0 mt-1'><strong>Sunil Kumar</strong></p>
                            <p className='font-xss mb-0'>sunilyadav@simulanis.com</p>
                            <div className='score'>
                                <h6 className='mb-0'>Score</h6>
                                <h2>21354</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChampCard
